import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Path } from '@src/suite/common/data-models/complex-types/path';
import { NavigationDirection } from '@src/suite/common/enums/navigation-direction';

export const PlaybookApiActions = createActionGroup({
    source: 'Playbook',
    events: {
        'Load story templates': emptyProps(),
        'Load topic templates': emptyProps(),
        'Load templates error': props<{ error: string }>(),
        'Create assignment': props<{ topic: StorytellingTopicRecord; assignmentType: string }>(),
        'Create Story From Template': props<{ topic: StorytellingTopicRecord; templateProgramId: string; templateGuids: Array<string>; openStory?: boolean }>(),
        'Create topic': props<{ topic: StorytellingTopicRecord; createAndNext: boolean; discoverItemDatabase?: string; discoverItemPath?: Path; discoverItemGuid?: string }>(),
        'Prepare Create topic': props<{ topic: StorytellingTopicRecord; createAndNext: boolean }>(),
        'Create record done': emptyProps(),
        'Create story': props<{ story: StorytellingStoryRecord; createAndNext: boolean }>(),
        'Save story': props<{ story: StorytellingStoryRecord }>(),
    },
});

export const PlaybookActions = createActionGroup({
    source: 'Playbook',
    events: {
        'Navigate To Topic': props<{ currentNodeUuid: string; direction?: NavigationDirection }>(),
        'Set start index': props<{ startIndex: number }>(),
        'Set page size': props<{ pageSize: number }>(),
    },
});
